export function PrivacyPolicyPage() {
  return (
    <div className="space-y-6 max-w-4xl">
      <div>
        <h1 className="text-2xl font-bold">Privacy Policy</h1>
        <p className="text-sm text-ink-muted mt-1">Effective date: 2026-06-13</p>
      </div>

      <div className="card space-y-3 text-sm leading-6 text-ink-muted">
        <h2 className="text-base font-semibold text-ink">1. Who we are</h2>
        <p>
          AI Security & Compliance Hub is provided by Shenzhen Intellnet Technology Co., Ltd.
          For privacy inquiries, contact privacy@intellnet.cn.
        </p>

        <h2 className="text-base font-semibold text-ink">2. Personal information we collect</h2>
        <p>We collect the following categories of personal information as needed to provide the service:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Account and identity information, such as name, business email, tenant identifier, and role.</li>
          <li>Authentication and security data, such as sign-in events, MFA status, and access audit logs.</li>
          <li>Service usage and diagnostic data, such as feature usage, system events, and error logs.</li>
          <li>Support and communication data, such as tickets, messages, and troubleshooting context you provide.</li>
          <li>Billing and subscription metadata from Microsoft Marketplace, such as subscription and plan identifiers.</li>
        </ul>

        <h2 className="text-base font-semibold text-ink">3. How we use personal information</h2>
        <p>We use personal information to:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Authenticate users and control role-based access to the service.</li>
          <li>Deliver security posture, privacy assessment, and compliance reporting features.</li>
          <li>Maintain platform reliability, detect abuse, and protect customer environments.</li>
          <li>Provide customer support, respond to requests, and improve service quality.</li>
          <li>Meet legal, accounting, and contractual obligations.</li>
        </ul>

        <h2 className="text-base font-semibold text-ink">4. Legal bases for processing</h2>
        <p>
          Depending on your jurisdiction, we process personal information based on contract performance,
          legitimate interests in securing and operating the service, compliance with legal obligations,
          and consent where required.
        </p>

        <h2 className="text-base font-semibold text-ink">5. Sharing and disclosure</h2>
        <p>We do not sell personal information. We may share data only with:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Infrastructure and security subprocessors required to operate the service on Microsoft Azure.</li>
          <li>Professional advisors or authorities when required by law or to protect legal rights and safety.</li>
          <li>Corporate affiliates for internal administration under equivalent privacy safeguards.</li>
        </ul>

        <h2 className="text-base font-semibold text-ink">6. International data transfers</h2>
        <p>
          Data may be processed in regions where we or our subprocessors operate.
          We apply contractual and technical safeguards for cross-border transfers,
          including encryption and access controls.
        </p>

        <h2 className="text-base font-semibold text-ink">7. Data retention</h2>
        <p>
          We retain personal information only for as long as necessary to provide the service,
          fulfill contractual commitments, resolve disputes, enforce agreements, and comply with legal obligations.
          Retention periods vary by data type and customer configuration.
        </p>

        <h2 className="text-base font-semibold text-ink">8. Security measures</h2>
        <p>
          We apply administrative, technical, and organizational controls, including encryption in transit and at rest,
          least-privilege access, logging, monitoring, and secret management through Azure Key Vault.
        </p>

        <h2 className="text-base font-semibold text-ink">9. Your privacy rights</h2>
        <p>
          Subject to applicable law, you may have rights to request access, correction, deletion,
          portability, restriction, or objection to processing, and to withdraw consent where processing is consent-based.
          You may also have the right to lodge a complaint with a supervisory authority.
        </p>

        <h2 className="text-base font-semibold text-ink">10. Children</h2>
        <p>
          The service is designed for enterprise users and is not directed to children.
          We do not knowingly collect personal information from children.
        </p>

        <h2 className="text-base font-semibold text-ink">11. Changes to this policy</h2>
        <p>
          We may update this Privacy Policy from time to time.
          Material changes will be posted on this page with an updated effective date.
        </p>

        <h2 className="text-base font-semibold text-ink">12. Contact</h2>
        <p>
          To submit privacy requests (including access, correction, deletion, portability, or objection),
          contact privacy@intellnet.cn.
        </p>
      </div>
    </div>
  );
}
